function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.462 46.448c5.593 5.736 9.321 5.736 14.914 0",
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "scale(-1 1) rotate(-8.175)",
  cx: -24.701,
  cy: 42.797,
  rx: 2.868,
  ry: 0.574,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-8.175)",
  cx: 32.436,
  cy: 51.005,
  rx: 2.868,
  ry: 0.574,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.965 37.27c6.193 4.718 5.736 10.325 2.295 12.62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.615 37.27c-6.193 4.718-5.736 10.325-2.295 12.62",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.965 37.27c-3.061-1.504-6.056-5.141-8.289-33.27"
}));

var SvgNose = function SvgNose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Nose.9302e830.svg";
export { ForwardRef as ReactComponent };